const ResultType = {
    'Hit': { key: 'H', name: 'Hit'},
    'Pitch': { key: 'P', name: 'Pitch'},
    'PitchHit': { key: 'PH', name: 'Pitch and Hit'},

    hasPitch(type) {
        switch (type) {
            case this.Pitch.key:
            case this.PitchHit.key:
                return true;
        
            default:
                return false;
        }
    },
    hasHit(type) {
        switch (type) {
            case this.Hit.key:
            case this.PitchHit.key:
                return true;
        
            default:
                return false;
        }
    },
};

export default ResultType;